import EmailsDirToolBar from '../EmailsDirToolBar';
import EmailsTable from '../EmailsTable';


const TabClients = () => (
    <>
        <EmailsDirToolBar tab="clients" />
        
        <EmailsTable />
    </>
);

export default TabClients;
